const getters = {
    permissions: (state) => state.permissions,
    loading: state => state.loading
};

export default getters;